import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import {
	fireLoomCjnEligibilityChecked,
	getCustomExperimentAnalytics,
} from '../../services/analytics.ts';
import type { LoomEventCacheKey, LoomEventCacheValue } from '../../services/caching.ts';
import { cjnLoomEventCacheController } from '../../services/caching.ts';

/**
 * This is mostly a duplicate of useFireOnlyNewEvent, but with a different cache controller
 * that is also duplicated to be specific for Loom JCN events due to the different shape of the eligibility
 * check response. These functions should be refactored into a single reusable hook as part of productionisation.
 **/
export const useFireOnlyNewLoomEvent = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const customAnalytics = getCustomExperimentAnalytics('crossJoinNudges', createAnalyticsEvent);

	/**
	 * Fire event only in case the event value has not been cached or cached value is different
	 * to prevent excessive number of analytics calls.
	 */
	return useCallback(
		({ value, key }: { value: LoomEventCacheValue; key: LoomEventCacheKey | string }) => {
			try {
				const cachedValue = cjnLoomEventCacheController.get(key);
				if (
					!cachedValue ||
					cachedValue.eligible !== value.eligible ||
					cachedValue.ineligibilityReason !== value.ineligibilityReason
				) {
					fireLoomCjnEligibilityChecked(customAnalytics, {
						...value,
						key,
					});
					cjnLoomEventCacheController.set(key, value);
				}
			} catch (e) {
				// cache get fail, do nothing
			}
		},
		[customAnalytics],
	);
};
